<template>
  <div class="empty-state">
    <div class="empty-image">
      <img :src="imageSrc" :alt="description" />
    </div>
    <div class="empty-text">
      <div class="empty-title">{{ title }}</div>
      <div class="empty-description" v-if="description">{{ description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      default: '暂无数据'
    },
    description: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: 'empty-data'
    }
  },
  computed: {
    imageSrc() {
      try {
        // 先尝试PNG格式
        return require(`@/assets/images/${this.image}.png`);
      } catch (e) {
        try {
          // 再尝试SVG格式
          return require(`@/assets/images/${this.image}.svg`);
        } catch (e2) {
          // 如果都找不到，使用默认的SVG空状态图片
          return require('@/assets/images/empty-data.svg');
        }
      }
    }
  }
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  text-align: center;
  min-height: 180px;
  width: 100%;
  box-sizing: border-box;
}

.empty-image {
  margin-bottom: 16px;
}

.empty-image img {
  width: 80px;
  height: 80px;
  opacity: 0.7;
}

.empty-text {
  color: #909399;
}

.empty-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.empty-description {
  font-size: 14px;
  color: #909399;
  line-height: 1.4;
}
</style>
